import React, { useState, useEffect, useCallback } from 'react';
import { Icon, Menu, Dropdown } from 'antd';
import { useTranslation } from 'react-i18next';
import PageNotFoundIllustration from '../../images/generatingPreview.png';
import URL from '../../utils/helper';
import { dayConversion, monthConversion } from '../../utils/javascript';
import { EMAIL_TEMPLATES_LIST } from './translationValues';
import { TemplatePageOverview, TemplateImage, DropdownDetails } from './styles';
import { useSessionContext } from '../../context/sessionContext';
import { checkUserAccessRoles } from '../../utils/helper';

const THUMBNAIL_KEY = 'thumbnail';
const NAMESPACES = ['EMAIL_TEMPLATES_LIST'];

const generateBlockThumbnail = id =>
  `${URL.DESIGN_SYSTEM_URL}email/standalone/block/thumbnail/${id}`;

export const EmailBlockTemplate = props => {
  const { t } = useTranslation(NAMESPACES);
  const { templateObj, categoriesTemp, redirectToTemplate, enableModalVisibility, categoryByTemplate } = props;
  const [firstPageImageLink, setFirstPageImageLink] = useState(
    templateObj[THUMBNAIL_KEY] ? templateObj[THUMBNAIL_KEY] : undefined,
  );
  const [loading, setLoading] = useState(true);

  const sessionSelector = useCallback(store => store.userData, []);
  const [userDetails] = useSessionContext(sessionSelector);

  const isReusableContentManager = checkUserAccessRoles(userDetails, ['REUSABLECONTENTMANAGER']);

  useEffect(() => {
    if (!templateObj[THUMBNAIL_KEY]) {
      setLoading(true);
      setFirstPageImageLink(generateBlockThumbnail(categoryByTemplate.id));
    }
  }, [templateObj, categoryByTemplate]);

  const onImageError = useCallback(() => {
    setFirstPageImageLink(undefined);
    setLoading(false);
  }, []);

  const onLoad = useCallback(() => {
    setLoading(false);
  }, []);

  return (
    <div key={categoryByTemplate.id}>
      <div className="test">
        <TemplatePageOverview
          key={categoryByTemplate.id}
          title={categoryByTemplate.name}
          onClick={() => redirectToTemplate(templateObj)}
        >
          <TemplateImage className={loading ? 'show-loader' : ''}>
            <div className="image-wrapper">
              <div key={categoryByTemplate.categoryId} className="preview-image-div">
                <img
                  src={firstPageImageLink ? firstPageImageLink : PageNotFoundIllustration}
                  alt="pageObj-thumbnail"
                  className={!firstPageImageLink ? 'no-thumbnail' : ''}
                  onError={onImageError}
                  onLoad={onLoad}
                />
              </div>
            </div>
            <DropdownDetails
              id={`${categoryByTemplate.id}-template`}
              className="dropdown-menu"
              onClick={e => e.stopPropagation()}
            >
              <Dropdown
                overlay={
                  <Menu>
                    <Menu.Item key="0" onClick={() => redirectToTemplate(templateObj)}>
                      {t(
                        EMAIL_TEMPLATES_LIST.EDIT_TEMPLATE_DROPDOWN_OPTION.key,
                        EMAIL_TEMPLATES_LIST.EDIT_TEMPLATE_DROPDOWN_OPTION.value,
                      )}
                    </Menu.Item>
                    {isReusableContentManager && <Menu.Item
                      key="1"
                      onClick={() =>
                        enableModalVisibility('delete-mail-template', categoryByTemplate)
                      }
                    >
                      {t(
                        EMAIL_TEMPLATES_LIST.DELETE_TEMPLATE_DROPDOWN_OPTION.key,
                        EMAIL_TEMPLATES_LIST.DELETE_TEMPLATE_DROPDOWN_OPTION.value,
                      )}
                    </Menu.Item>}
                  </Menu>
                }
                trigger={['click']}
                getPopupContainer={() =>
                  document.getElementById(`${categoryByTemplate.id}-template`)
                }
              >
                <Icon type="more" />
              </Dropdown>
            </DropdownDetails>
          </TemplateImage>
          <div className="template_name">
            <div className="name" onClick={() => redirectToTemplate(templateObj)}>
              {categoryByTemplate.name}{' '}
            </div>
            <div className="categoryName">
              <div className="box2"></div>
              {categoriesTemp.length > 0 &&
                categoriesTemp.map(category => (
                  <div key={category.categoryId}>
                    {templateObj.categoryId === category.categoryId && category.categoryName}
                  </div>
                ))}
            </div>

            {(templateObj.updatedOn || templateObj.createdOn) && (
              <div className="template_date">
                <p>
                  {templateObj.updatedOn
                    ? dayConversion(templateObj.updatedOn)
                    : dayConversion(templateObj.createdOn)}
                </p>
                <p className="month">
                  {templateObj.updatedOn
                    ? monthConversion(templateObj.updatedOn)
                    : monthConversion(templateObj.createdOn)}
                </p>
              </div>
            )}
          </div>
        </TemplatePageOverview>
      </div>
    </div>
  );
};
